import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs/index';
import { EnvironmentService } from '../environment.service';
import { catchError, tap } from 'rxjs/internal/operators';
import * as _ from 'underscore';
@Injectable({
  providedIn: 'root'
})
export class MonthlyactiveuserService {
  err: any;
  apiUrl;
  username;
  password;
  httpOptions;
  constructor(private http: HttpClient, private envService: EnvironmentService) {
    this.apiUrl = this.envService.read('apiUrl');
    this.username = this.envService.getCredential('username');
    this.password = this.envService.getCredential('password');
    this.setHttpHeaders();
   }
   setHttpHeaders() {
    this.httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
    'Authorization': `Basic ${btoa(this.username + ':' + this.password)}`
        })
    };
  }
  
private handleError<T>(operation = 'operation', result?: T) {
  return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error('error on operation', operation, error); // log to console instead

      // TODO: better job of transforming error for user consumption
      // this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
  };
}


getResellerList(args): Observable<any> {
  return this.http.post<any>(`${this.apiUrl}/reseller/monthly/active/users`,args,
      this.httpOptions).pipe(
          tap(),
          catchError(this.handleError('getResellerList', this.err))
      );
}
}
